// ===== Utilitaires couleurs =====


export function getSetColor(
  value: number,
  target: number,
  inverse: boolean = false
): 'green' | 'yellow' | 'red' {
  if (!inverse) {
    if (value >= target) {
      return 'green';
    } else if (value >= target - 10) {
      return 'yellow';
    } else {
      return 'red';
    }
  } else {
    if (value <= target) {
      return 'green';
    } else if (value <= target + 10) {
      return 'yellow';
    } else {
      return 'red';
    }
  }
}

export function getSetColorClass(
  value: number,
  target: number,
  inverse: boolean = false
): string {
  const color = getSetColor(value, target, inverse);
  return `set-color-${color}`;
}

export function getSetColorLabel(
  value: number,
  target: number,
  inverse: boolean = false
): string {
  const color = getSetColor(value, target, inverse);

  switch (color) {
    case 'green':
      return 'Objectif atteint';
    case 'yellow':
      return 'Vigilance';
    case 'red':
      return 'Alerte';
    default:
      return '';
  }
}
